import { gql } from "graphql-request";
export const OVERVIEW_DOMAIN_OFFER_QUERY = gql`
    query getOverviewDomainOffers(
        $categoryId: Int
        $language: String!
        $domainId: Int
        $slugs: [String!]
    ) {
        allDomainOffers(domainId: $domainId, categoryId: $categoryId) {
            offers(
                orderByDesc: weight
                isDeleted: false
                isActive: true
                slugIn: $slugs
            ) {
                id
                languages
                categories {
                    id
                    name
                    title
                }
                quickOverview
                name
                weight
                slug
                slugAlias
                url(isActive: true, isDeleted: false, languageEq: $language) {
                    isMain
                    main {
                        url
                    }
                    url
                }
                defaultAffiliateLink {
                    link
                }
                translations {
                    key
                    value
                    language
                }
                attributes(isDeleted: false) {
                    value
                    id
                    translations {
                        key
                        value
                        language
                    }
                    baseAttribute(categoryId: $categoryId) {
                        weight
                        comparison
                        name
                        groupSlug
                        forceComparisonsDisplay
                        type
                        attributesGroup {
                            id
                        }
                        translations {
                            key
                            value
                            language
                        }
                    }
                }
                features(languageEq: $language) {
                    description
                    translations {
                        key
                        value
                        language
                    }
                }
                pros(languageEq: $language) {
                    description
                    translations {
                        key
                        value
                        language
                    }
                }
                cons(languageEq: $language) {
                    description
                    translations {
                        key
                        value
                        language
                    }
                }
                logo {
                    fullPath
                }
            }
        }
    }
`;
